import { useCallback, useContext, useMemo } from 'react'
import { UGEContext } from '../../../context'
import { aspectRatioFromCropType } from '../../../utilities/crop-type'
import { Subheading } from '../../style'
import { Ext, NumberInput } from './style'

type Props = {
    className?: string
}

const UGECropEditorResize = ({ className }: Props) => {
    const { crop, cropType, dimensions, setCrop } = useContext(UGEContext)

    const aspectRatio = useMemo(
        () => aspectRatioFromCropType(cropType, dimensions.width / dimensions.height),
        [cropType, dimensions]
    )
    const cropHeight = crop?.height || dimensions.height
    const cropWidth = crop?.width || dimensions.width

    function updateCrop(width: number, height: number) {
        if (crop) {
            setCrop({ ...crop, height, width })
        } else {
            setCrop({ height, width, x: 0, y: 0 })
        }
    }

    const onHeightChange = useCallback(
        (value: number) => {
            updateCrop(aspectRatio ? Math.round(value * aspectRatio) : cropWidth, value)
        },
        [aspectRatio, cropWidth]
    )

    const onWidthChange = useCallback(
        (value: number) => {
            updateCrop(value, aspectRatio ? Math.round(value / aspectRatio) : cropHeight)
        },
        [aspectRatio, cropHeight]
    )

    return (
        <div className={className}>
            <Subheading>
                Resize <span>(Pixels)</span>
            </Subheading>
            <NumberInput
                extension={<Ext>W</Ext>}
                max={dimensions.width}
                min={0}
                value={cropWidth}
                onChange={onWidthChange}
            />
            <NumberInput
                extension={<Ext>H</Ext>}
                max={dimensions.height}
                min={0}
                value={cropHeight}
                onChange={onHeightChange}
            />
        </div>
    )
}

export default UGECropEditorResize
